import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

export const getTreatments = () => api.get("/treatments").then(r => r.data);
export const getTreatment = (slug) => api.get(`/treatments/${slug}`).then(r => r.data);
export const getJournal = () => api.get("/journal").then(r => r.data);
export const getArticle = (slug) => api.get(`/journal/${slug}`).then(r => r.data);
export const getArtworks = () => api.get("/artworks").then(r => r.data);
export const search = (q) => api.get(`/search`, { params: { q } }).then(r => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then(r => r.data);
export const subscribeNewsletter = (email, firstName) => api.post("/newsletter", { email, first_name: firstName || null }).then(r => r.data);
export const recommend = (payload) => api.post("/recommend", payload).then(r => r.data);
export const getReviews = () => api.get("/reviews").then(r => r.data);
export const joinBreathworkWaitlist = (payload) => api.post("/breathwork-waitlist", payload).then(r => r.data);

export const SQUARE_BOOKING_URL = "https://studioanissa.square.site/s/appointments";
